import { useOutletContext } from "react-router-dom";
import { useData } from "../../context/DataContext";
import { C } from "../../styles/theme";
import { ABt, exportCSV } from "../AdminUI";

export default function KanbanTab() {
  const { db, saveDB } = useData();
  const { toast } = useOutletContext();
  const save = r => { saveDB("leads", r); toast("Updated"); };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
        <p style={{ color: "#64748b", fontSize: 13, margin: 0 }}>Visual pipeline — move leads across stages.</p>
        <ABt variant="orange" onClick={() => exportCSV("leads", db.leads || [], [["Name", "name"], ["Email", "email"], ["Phone", "phone"], ["Service", "service"], ["Status", "status"], ["Date", "date"]], toast)}>Export Leads CSV</ABt>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(5,1fr)", gap: 12, overflowX: "auto" }}>
        {["new", "contacted", "in-progress", "converted", "lost"].map(st => {
          const colLeads = (db.leads || []).filter(l => l.status === st);
          const cColors = { new: "#1e40af", contacted: "#854d0e", "in-progress": "#6b21a8", converted: "#166534", lost: "#991b1b" };
          const cBgs = { new: "#dbeafe", contacted: "#fef9c3", "in-progress": "#f3e8ff", converted: "#dcfce7", lost: "#fee2e2" };
          return (
            <div key={st} style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 11, overflow: "hidden", minHeight: 200 }}>
              <div style={{ background: cBgs[st], padding: "10px 12px", borderBottom: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontSize: 12, fontWeight: 700, color: cColors[st], textTransform: "capitalize" }}>{st}</span>
                <span style={{ background: "#fff", color: cColors[st], fontSize: 11, fontWeight: 700, padding: "2px 8px", borderRadius: 20 }}>{colLeads.length}</span>
              </div>
              <div style={{ padding: "10px 10px", display: "flex", flexDirection: "column", gap: 8 }}>
                {colLeads.map(l => (
                  <div key={l.id} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, padding: "10px 11px", boxShadow: "0 1px 4px rgba(0,0,0,.04)" }}>
                    <div style={{ fontWeight: 700, color: C.dark, fontSize: 13, marginBottom: 3 }}>{l.name}</div>
                    <div style={{ fontSize: 11, color: C.orange, fontWeight: 600, marginBottom: 4 }}>{l.service}</div>
                    <div style={{ fontSize: 11, color: "#94a3b8", marginBottom: 7 }}>{l.company || l.email}</div>
                    <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                      {["new", "contacted", "in-progress", "converted", "lost"].filter(s => s !== st).slice(0, 2).map(s => (
                        <button key={s} onClick={() => save({ ...l, status: s })} style={{ background: "#f1f5f9", border: "1px solid #e2e8f0", color: "#475569", fontSize: 10, padding: "2px 7px", borderRadius: 4, cursor: "pointer", fontWeight: 600, whiteSpace: "nowrap" }}>to {s}</button>
                      ))}
                    </div>
                  </div>
                ))}
                {!colLeads.length && <div style={{ textAlign: "center", padding: "16px 8px", color: "#94a3b8", fontSize: 12 }}>No leads</div>}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
